import { Button, Popconfirm, Space } from 'antd'

import AdministratorTable from 'components/Table/Administrator'
import TableColumnFormat from 'components/Table/ColumnFormat'
import TotalDataSourceText from 'components/Table/TotalDataSourceText'
import Status from 'components/Status'

import person from 'assets/images/person.png'

import { appLocalOrgKey } from 'utils/localService'

import ActionNameDashboard from '../utils/ActionNameDashboard'

import type { ColumnType } from 'antd/lib/table'
import type { MemberOrganizationAPIPayload } from 'graphQL/useGetMemberOrganization/interface'
import type { MemberProps } from './interface'

const Member: React.FC<MemberProps> = ({ memberList, onDeleteUserOrganization }) => {
  const noDataText = '- ไม่มีข้อมูล -'

  const columns: ColumnType<MemberOrganizationAPIPayload>[] = [
    {
      title: () => <TableColumnFormat title="Name" subtitle="Display name" />,
      dataIndex: 'administratorName',
      render: (_text, record, index) => {
        const fullName =
          record.attribute?.firstName && record.attribute?.lastName
            ? `${record.attribute?.firstName} ${record.attribute?.lastName}`
            : noDataText
        return (
          <span key="manage" className="organization-action-link">
            <ActionNameDashboard
              key={`AdministratorName-${index}`}
              img={record.attribute?.picture || person}
              name={fullName}
            />
          </span>
        )
      },
    },
    {
      title: () => <TableColumnFormat title="Email" subtitle="Email address" />,
      dataIndex: 'administratorEmail',
      render: (_text, record) => <Space size={12}>{record.email[0]?.value || noDataText}</Space>,
    },
    {
      title: () => <TableColumnFormat title="Status" subtitle="Active / Deactive" />,
      dataIndex: 'administratorStatus',
      render: (_text, record) => (
        <Space size={12}>
          <Status key="status" status={record.email[0]?.verifyStatus || noDataText} />
        </Space>
      ),
    },
    {
      dataIndex: 'administratorAction',
      render: (_text, record) => {
        const orgKey = appLocalOrgKey.get() || ''

        return (
          <Popconfirm title="คุณแน่ใจที่จะลบไหม?" onConfirm={() => onDeleteUserOrganization(record._id, orgKey)}>
            <Button type="primary" danger>
              ลบสมาชิกคนนี้
            </Button>
          </Popconfirm>
        )
      },
    },
  ]

  return (
    <>
      <AdministratorTable<MemberOrganizationAPIPayload> dataSource={memberList || []} columns={columns} rowKey="_id" />
      <TotalDataSourceText total={(memberList || []).length} />
    </>
  )
}

export default Member
